//import Vue from 'vue';
//import VueRouter, { RouteConfig } from 'vue-router';
import { createRouter, createWebHistory, RouteRecordRaw, RouteLocationNormalizedLoaded } from 'vue-router'; // Vue Router 4の関数と型をインポート

import Home from '@/views/Home.vue';
import ClassRecord from '@/views/ClassRecord.vue';
import ChildRecord from '@/views/ChildRecord.vue';
import Chat from '@/views/Chat.vue';
import Draft from '@/views/Draft.vue';
import ReadySendBox from '@/views/ReadySendBox.vue';
import NewMessage from '@/views/NewMessage.vue';
import SignIn from '../views/SignIn.vue';
import SignUp from '../views/SignUp.vue';
import ChangeNursery from '../views/ChangeNursery.vue';
import EventCalender from '../views/EventCalender.vue';
import ChangeNotification from '../views/ChangeNotification.vue';
import ClassDiary from '../views/ClassDiary.vue';
import ParentsRecord from '../views/ParentsRecord.vue';
import Maintenance from '../views/Maintenance.vue';
import MemoruAlbum from '../views/memoru/MemoruAlbum.vue';
import AiReportTop from '@/views/ai-report/AiReportTop.vue';
import AiReportQuarter from '@/views/ai-report/AiReportQuarter.vue';
import AiReportDetail from '@/views/ai-report/AiReportDetail.vue';

//Vue.use(VueRouter);

//const routes: RouteConfig[] = [
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/communication/chat/:childId',
    name: 'Chat',
    component: Chat,
  },
  {
    path: '/communication/draft',
    name: 'Draft',
    component: Draft,
  },
  {
    path: '/communication/ready-send-box',
    name: 'ReadySendBox',
    component: ReadySendBox,
  },
  {
    path: '/communication/new-message',
    name: 'NewMessage',
    component: NewMessage,
  },
  {
    path: '/record/class/:classId',
    name: 'ClassRecord',
    component: ClassRecord,
  },
  {
    path: '/record/class/:classId/child/:childId',
    name: 'ChildRecord',
    component: ChildRecord,
  },
  {
    path: '/record/class-diary/:classId',
    name: 'ClassDiary',
    component: ClassDiary,
  },
  {
    path: '/record/parents-record/class/:classId/child/:childId',
    name: 'ParentsRecord',
    component: ParentsRecord,
  },
  {
    path: '/album/:albumId',
    name: 'MemoruAlbum',
    component: MemoruAlbum,
  },
  {
    path: '/signin',
    name: 'SignIn',
    component: SignIn,
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp,
  },
  {
    path: '/change-nursery',
    name: 'ChangeNursery',
    component: ChangeNursery,
  },
  {
    path: '/event-calender',
    name: 'EventCalender',
    component: EventCalender,
  },
  // {
  //   path: '/memoru',
  //   name: 'MemoruTop',
  //   component: MemoruTop,
  // },
  {
    path: '/change-notification',
    name: 'ChangeNotification',
    component: ChangeNotification,
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: Maintenance,
  },
  {
    path: '/ai-report',
    name: 'AiReportTop',
    component: AiReportTop,
  },
  {
    path: '/ai-report/quarter/:businessYear/:quarter',
    name: 'AiReportQuarter',
    component: AiReportQuarter,
  },
  {
    path: '/ai-report/detail/:businessYear/:quarter/:childId',
    name: 'AiReportDetail',
    component: AiReportDetail,
  },
];

// ----------------------------------------------------
// ★ 変更点 2: createRouter 関数と createWebHistory を使用
// ----------------------------------------------------
const router = createRouter({
  // 'mode: history' の代わりに createWebHistory 関数を使用
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
/*
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
*/

/*
router.beforeResolve((to, from, next) => {
  const maintenanceMode = process.env.VUE_APP_MANTENANCE_MODE;
  const toQuery = to.query;
  const fromQuery = from.query;
  const toPath = to.path;

  const isMaintenanceMode = maintenanceMode && maintenanceMode === 'true';
  const toMagicWord = toQuery.vadar && toQuery.vadar === 'anakin';
  const fromMagicWord = fromQuery.vadar && fromQuery.vadar === 'anakin';

  if (isMaintenanceMode) {
    if (toMagicWord) {
      if (toPath === '/maintenance') {
        next('/home');
        return;
      }
      next();
      return;
    }

    if (fromMagicWord) {
      // ここで to のクエリーに from のクエリーを渡す
      const query = Object.assign(to.query, { vadar: 'anakin' });
      next({ name: to.name || '', params: to.params, query });
      return;
    }

    // should go to maintenance
    if (toPath === '/maintenance') {
      next();
      return;
    }
    next('/maintenance');
    return;
  }

  // maintenanceMode = false
  if (toPath === '/maintenance') {
    next('/home');
    return;
  }

  if (to.path === '/signin') {
    next();
  } else {
    next();
    return;
  }
});

export default router;
*/

// ----------------------------------------------------
// ★ 変更点 3: beforeResolve の to, from の型を修正
// ----------------------------------------------------
router.beforeResolve((to: RouteLocationNormalizedLoaded, from: RouteLocationNormalizedLoaded, next) => {
  // Vue 3では環境変数のアクセス方法が変更されている可能性があるため、その点も注意が必要です
  const maintenanceMode = process.env.VUE_APP_MANTENANCE_MODE; 
  const toQuery = to.query;
  const fromQuery = from.query;
  const toPath = to.path;

  const isMaintenanceMode = maintenanceMode && maintenanceMode === 'true';
  const toMagicWord = toQuery.vadar && toQuery.vadar === 'anakin';
  const fromMagicWord = fromQuery.vadar && fromQuery.vadar === 'anakin';

  if (isMaintenanceMode) {
    if (toMagicWord) {
      if (toPath === '/maintenance') {
        next('/home');
        return;
      }
      next();
      return;
    }

    if (fromMagicWord) {
      // ここで to のクエリーに from のクエリーを渡す
      const query = Object.assign({}, to.query, { vadar: 'anakin' }); // Object.assignの第一引数は空オブジェクトにすることを推奨
      // Vue Router 4では name がない場合を考慮して型アサーションやチェックを行う
      next({ name: to.name as string || undefined, params: to.params, query });
      return;
    }

    // should go to maintenance
    if (toPath === '/maintenance') {
      next();
      return;
    }
    next('/maintenance');
    return;
  }

  // maintenanceMode = false
  if (toPath === '/maintenance') {
    next('/home');
    return;
  }

  // Vue Router 4では、next() の後に return を入れなくてもTypeScriptのエラーは出ませんが、
  // 意図を明確にするために、制御を終了する箇所で return を入れても問題ありません。
  if (to.path === '/signin') {
    next();
  } else {
    next();
    return;
  }
});

export default router;
